export default __webpack_public_path__ + "static/media/quality-video.01aa4b20.svg";